// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c3b6154","732":"ecf6d549","977":"64150131"}[chunkId] + ".chunk.js";
};